import styled, { withTheme } from 'styled-components';
import SignIcon from '../../assets/images/document-sign-icon-dynamic.svg?react';

const SignIconDynamic = styled(SignIcon)`
  background-size: 32px 22px;
  display: inline-block;
  position: relative;
  width: 32px;
  height: 22px;

  ${(props) => props.theme.palette.type === 'dark'} {
    fill: ${(props) => props.theme.palette.common.coral};
  }
  ${(props) => props.theme.palette.type === 'light'} {
    fill: ${(props) => props.theme.palette.common.coral};
  }
`;
export default withTheme(SignIconDynamic);
